module.exports = __webpack_public_path__ + "img/map_logo_marketing_and_sales.4909eb3f.jpg";